import { render, staticRenderFns } from "./cms-select.vue?vue&type=template&id=3c2152cf&scoped=true&"
import script from "./cms-select.vue?vue&type=script&lang=js&"
export * from "./cms-select.vue?vue&type=script&lang=js&"
import style0 from "./cms-select.vue?vue&type=style&index=0&id=3c2152cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2152cf",
  null
  
)

export default component.exports